<template>
  <div v-if="category !== null">
    <b-card>
      <h1 class="mb-3">Editr Category</h1>
      <b-form>
        <b-row>
          <!-- Field: name -->
          <b-col cols="12" md="6">
            <b-form-group label="name" label-for="name">
              <b-form-input id="name" v-model="category.name" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <language-picker
              @getLanguage="setLanguage"
              :defaultLanguageId="category.languageId"
            ></language-picker>
          </b-col>
          <b-col cols="12" md="6">
            <b-form @submit.prevent>
              <b-form-group label="Seo title" label-for="seoTitle">
                <b-form-input
                    id="seoTitle"
                    trim
                    placeholder=""
                    v-model="category.seoTitle"
                />
              </b-form-group>
            </b-form>
          </b-col>
          <b-col cols="12" md="6">
            <b-form @submit.prevent>
              <b-form-group label="Seo Url" label-for="seoURL">
                <b-form-input
                    id="seoURL"
                    trim
                    placeholder=""
                    v-on:focus="$event.target.select()"
                    v-model="allCharactersToDash"
                />
              </b-form-group>
            </b-form>
          </b-col>
          <b-col cols="12">
            <b-form @submit.prevent>
              <b-form-group label="Seo Description" label-for="seoDescription">
                <b-form-textarea
                    id="seoDescription"
                    trim
                    placeholder=""
                    v-model="category.seoDescription"
                />
              </b-form-group>
            </b-form>
          </b-col>
          <b-col cols="12">
            <!--- serp Desktop --->
            <div class="serp-preview d-lg-flex p-3 d-none flex-column align-items-start">
              <div class="serp-title">
                <h4 style="color: rgb(26, 13, 171) !important">
                  {{ category.seoTitle }}
                </h4>
              </div>
              <div class="serp-url">
                <!--              <span class="serp-arrow"></span>-->
                <h5 class="d-flex align-items-center flex-wrap"
                    style="color: rgb(0, 102, 33) !important">
                        <span>
                          {{ `https://ariaexport.com/blogTag/` }}
                        </span>
                  <span style="overflow-wrap: anywhere">{{ allCharactersToDash }}</span>
                </h5>
              </div>
              <div class="serp-description">
                <h6 style="overflow-wrap: anywhere">
                  {{ category.seoDescription }}
                </h6>
              </div>
            </div>
            <!--- serp Mobile --->
            <div class="serp-preview d-lg-none p-3 d-flex flex-column align-items-start">
              <div class="serp-title">
                <h6>
                  {{ category.seoTitle }}
                </h6>
              </div>
              <div class="serp-url d-flex align-items-center flex-wrap">
                <small>
                  {{ `https://ariaexport.com/blogTag/` }}
                  <!--                <small class="serp-arrow"></small>-->
                </small>
                <small>{{ allCharactersToDash }}</small>
              </div>
              <div class="serp-description">
                <small>
                  {{ category.seoDescription }}
                </small>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-form>

      <!-- Action Buttons -->
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button
          variant="primary"
          class="mt-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="updateCategory"
        >
          Save
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import LanguagePicker from "../../../components/utils/LanguagePicker.vue";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BForm,
  BModal, BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BlogCategoryUpdateRequest,
  BlogCategoryGetRequest,
} from "@/libs/Api/Blogex";

export default {
  name: "categories-edit",
  title: "Edit category",
  data() {
    return {
      category: null,
      categoryProperties: null,
      categoryId: this.$route.params.id,
      addNewCategoryProperty: false,
      myTableColumns: [
        { key: "categoryPropertyId", label: "شناسه" },
        { key: "name", label: "نام" },
        { key: "delete", label: "حذف" },
        { key: "edit", label: "ویرایش" },
      ],
      defaultCreateCategoryPropertyData: {
        isDeleted: false,
        categoryPropertyId: 0,
        categoryId: this.$route.params.id,
        name: "",
        seourl:null,
        seoTitle:null,
        seoDescription:null
      },
      updateCategoryPropertyData: null,
    };
  },
  computed:{
    allCharactersToDash: {
      get: function () {
        return this.category.seourl;
      },
      set: function (newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.category.seourl = newValue
          // Remove all characters that are NOT number
          this.category.seourl = this.category.seourl.replace(/[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\/\.]/g, "");
          this.category.seourl = this.category.seourl.replaceAll(' ', '-')
        } else if (!newValue || this.category.seourl === "") {
          this.category.seourl = null;
        }
      },
    },
  },
  async created() {
    await this.getCategory();
  },
  methods: {
    setLanguage(language) {
      this.category.languageId = language.languageId;
    },
    async getCategory() {
      let _this = this;

      let blogCategoryGetRequest = new BlogCategoryGetRequest(_this);
      blogCategoryGetRequest.setId(_this.categoryId);
      await blogCategoryGetRequest.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.category = response.data;
          }
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async updateCategory() {
      let _this = this;

      let blogCategoryUpdateRequest = new BlogCategoryUpdateRequest(_this);
      blogCategoryUpdateRequest.setParams(_this.category);
      await blogCategoryUpdateRequest.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: `Operation successful`,
                icon: "CheckIcon",
                variant: "success",
              },
            });
          }
          _this.getCategory();
        },
        function (error) {
          console.log(error);
        }
      );
    },
  },
  components: {
    BFormTextarea,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BFormGroup,
    BBadge,
    BForm,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    LanguagePicker,
    vSelect,
  },
};
</script>

<style scoped></style>
